export const SCREEN_SIZE = 'SCREEN';

export const setScreen = (data) => ({
    type: SCREEN_SIZE,
    payload: data
});